import { FACILITY_TYPE } from "./intxConstants";

export const FACILITY_TYPE_LABELS = {
  [FACILITY_TYPE.RURAL_PRINCIPAL_ARTERIAL]: "Rural Principal Arterial",
  [FACILITY_TYPE.RURAL_MINOR_ARTERIAL]: "Rural Minor Arterial",
  [FACILITY_TYPE.RURAL_MAJOR_COLLECTOR]: "Rural Major Collector",
  [FACILITY_TYPE.RURAL_MINOR_COLLECTOR]: "Rural Minor Collector",
  [FACILITY_TYPE.URBAN_PRINCIPAL_ARTERIAL]: "Urban Principal Arterial -- Other",
  [FACILITY_TYPE.URBAN_MINOR_ARTERIAL]: "Urban Minor Arterial",
  [FACILITY_TYPE.URBAN_MAJOR_COLLECTOR]: "Urban Major Collector",
};
